export default __webpack_public_path__ + "ide-project-images/7f0c1aebe3d36f5454ead1a6f582c067.png";